import { Box } from "@mui/material";

import type { DropTarget } from "../hooks/useTabDrag";
import type { SplitLayout } from "../hooks/useTabGroup";

interface DropZoneOverlaysProps {
  anyTabDragging: boolean;
  dropTarget: DropTarget;
  splitLayout: SplitLayout | null;
}

export function DropZoneOverlays({
  anyTabDragging,
  dropTarget,
  splitLayout,
}: DropZoneOverlaysProps) {
  return (
    <>
      {/* Drop zone overlays — visible only when a tab is being dragged */}
      {anyTabDragging && (
        <>
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "50%",
              height: "100%",
              backgroundColor: dropTarget === "left" ? "rgba(33, 150, 243, 0.35)" : "transparent",
              transition: "background-color 0.15s",
              pointerEvents: "none",
              zIndex: (theme) => theme.zIndex.modal + 55,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              width: "50%",
              height: "100%",
              backgroundColor: dropTarget === "right" ? "rgba(33, 150, 243, 0.35)" : "transparent",
              transition: "background-color 0.15s",
              pointerEvents: "none",
              zIndex: (theme) => theme.zIndex.modal + 55,
            }}
          />
          {/* Center divider */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top: 0,
              width: 3,
              height: "100%",
              backgroundColor: "rgba(33, 150, 243, 0.8)",
              transform: "translateX(-50%)",
              pointerEvents: "none",
              zIndex: (theme) => theme.zIndex.modal + 56,
            }}
          />
        </>
      )}
      {/* Permanent split divider when in split view */}
      {splitLayout && !anyTabDragging && (
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: 0,
            width: 3,
            height: "100%",
            backgroundColor: "grey.500",
            transform: "translateX(-50%)",
            pointerEvents: "none",
            zIndex: (theme) => theme.zIndex.modal + 52,
          }}
        />
      )}
    </>
  );
}
